<template>
  <sub-page title="用工备案信息查询">
    <div class="query-page">
      <div class="record-list">
        <div class="record-item" v-for="(item, idx) in recordList" :key="idx">
          <div class="record-main" @click="toggle(idx)">
            <div class="record-row">
              <span class="record-label">就业类型：</span>
              <span class="record-value">{{ item.type }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">岗位工种：</span>
              <span class="record-value">{{ item.job }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">单位名称：</span>
              <span class="record-value">{{ item.company }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">有效标记：</span>
              <span :class="['record-value', item.valid === '有效' ? 'txt-green' : 'txt-gray']">{{ item.valid }}</span>
            </div>
            <svg viewBox="0 0 24 24" :class="['record-arrow', { open: activeIdx === idx }]"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>

          <!-- 备案明细 -->
          <div class="detail-box" v-if="activeIdx === idx">
            <div class="detail-row">
              <span class="detail-label">合同类型</span>
              <span class="detail-value">{{ item.contractType }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">合同开始日期</span>
              <span class="detail-value">{{ item.startDate }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">合同结束日期</span>
              <span class="detail-value">{{ item.endDate }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">用工备案日期</span>
              <span class="detail-value">{{ item.recordDate }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">解除（终止）日期</span>
              <span class="detail-value">{{ item.cancelDate }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">解除（终止）原因</span>
              <span class="detail-value">{{ item.cancelReason }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">备案经办机构</span>
              <span class="detail-value">{{ item.agency }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'WorkRecordQuery',
  components: { SubPage },
  data() {
    return {
      activeIdx: 0,
      recordList: [
        {
          type: '单位就业', job: '专业技术人员', company: '江苏超芯星半导体有限公司', valid: '有效',
          contractType: '固定期限劳动合同', startDate: '2024-03-18', endDate: '2027-03-17',
          recordDate: '2024-03-20', cancelDate: '——', cancelReason: '——', agency: '南京市江北新区社会事业局'
        },
        {
          type: '单位就业', job: '专业技术人员', company: '中锗科技有限公司', valid: '无效',
          contractType: '固定期限劳动合同', startDate: '2021-06-01', endDate: '2024-02-29',
          recordDate: '2021-06-04', cancelDate: '2024-02-29', cancelReason: '劳动者提出解除劳动合同', agency: '南京市溧水区人力资源和社会保障局'
        },
        {
          type: '单位就业', job: '专业技术人员', company: '南京思柏瑞信息科技有限公司', valid: '无效',
          contractType: '固定期限劳动合同', startDate: '2019-09-02', endDate: '2021-05-31',
          recordDate: '2019-09-05', cancelDate: '2021-05-31', cancelReason: '合同期满终止', agency: '南京市鼓楼区人力资源和社会保障局'
        },
        {
          type: '单位就业', job: '商业和其他服务业', company: '南京惠众人力资源服务有限公司', valid: '无效',
          contractType: '固定期限劳动合同', startDate: '2017-07-10', endDate: '2019-08-31',
          recordDate: '2017-07-12', cancelDate: '2019-08-31', cancelReason: '劳动者提出解除劳动合同', agency: '南京市建邺区人力资源和社会保障局'
        },
        {
          type: '单位就业', job: '商业和其他服务业', company: '南京科通通信工程技术服务有限公司', valid: '无效',
          contractType: '固定期限劳动合同', startDate: '2016-09-01', endDate: '2017-06-30',
          recordDate: '2016-09-06', cancelDate: '2017-06-30', cancelReason: '合同期满终止', agency: '南京市秦淮区人力资源和社会保障局'
        }
      ]
    }
  },
  methods: {
    toggle(idx) {
      this.activeIdx = this.activeIdx === idx ? -1 : idx
    }
  }
}
</script>

<style scoped>
.query-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(20 * var(--w)) calc(24 * var(--w));
}
.record-list {
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--w));
}
.record-item {
  background: #fff;
  border-radius: calc(12 * var(--w));
  overflow: hidden;
}
.record-main {
  padding: calc(24 * var(--w)) calc(32 * var(--w));
  position: relative;
  cursor: pointer;
}
.record-row {
  display: flex;
  align-items: center;
  font-size: calc(32 * var(--w));
  line-height: 1.8;
}
.record-label {
  color: #969799;
  white-space: nowrap;
}
.record-value {
  color: #323233;
}
.txt-green {
  color: #07A35A;
  font-weight: bold;
}
.txt-gray {
  color: #969799;
}
.record-arrow {
  position: absolute;
  right: calc(24 * var(--w));
  top: calc(28 * var(--w));
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  transition: transform 0.2s;
}
.record-arrow.open {
  transform: rotate(90deg);
}
.detail-box {
  border-top: 1px dashed #ebedf0;
  margin: 0 calc(32 * var(--w));
  padding: calc(16 * var(--w)) 0;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: calc(30 * var(--w));
  line-height: 2;
}
.detail-label {
  color: #969799;
  flex-shrink: 0;
  margin-right: calc(24 * var(--w));
}
.detail-value {
  color: #323233;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkRecordQuery.vue